
import BaseLayout from './BaseLayout.vue'

export default {
  name: 'Folder',
  components: {
    BaseLayout
  }
}
